import { useState } from "react";

export default function AdminLoginPanel({ onSubmit, onCancel }) {
  const [tokenInput, setTokenInput] = useState("");

  const submit = () => {
    if (!tokenInput.trim()) return;
    onSubmit(tokenInput.trim());
    setTokenInput("");
  };

  return (
    <div className="panel p-5 max-w-md flex flex-col gap-3" data-testid="admin-login-panel">
      <div className="font-mono text-[10px] uppercase tracking-[0.18em] muted">Enter admin token</div>
      <input
        type="password"
        autoFocus
        value={tokenInput}
        onChange={(e) => setTokenInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        className="terminal-input w-full px-3 py-2 text-sm font-mono"
        placeholder="Paste your admin token…"
        data-testid="admin-token-input"
      />
      <div className="flex gap-2">
        <button onClick={submit} className="btn-primary px-4 py-2 text-xs" data-testid="admin-login-submit">Unlock</button>
        <button onClick={onCancel} className="btn-secondary px-4 py-2 text-xs">Cancel</button>
      </div>
    </div>
  );
}
